import { Grid } from 'antd';

const { useBreakpoint } = Grid;

export const useDevice = () => {
	const screens = useBreakpoint();
	return {
		isMobile: !screens.lg,
	};
};
